import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';

@Injectable()
export class ToastService {
    constructor(
        private toastCtrl: ToastController) {
    }

    //加载显示
    public showToast(msg: string = "加载中...", position: string = "middle", duration: number = 3000) {
        let toast = this.toastCtrl.create({
            message: msg,
            duration: duration,
            position: position
        });

        toast.present();

        return toast;
    }

}


// WEBPACK FOOTER //
// ./src/providers/toast.service.ts